import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _dec2, _class, _descriptor, _descriptor2;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import SKU from "./SKU";
var MenuItemDetail = (_dec = observable.shallow, _dec2 = observable.ref, (_class = /*#__PURE__*/function () {
  function MenuItemDetail(rawMenuDetailAPIResponse) {
    _classCallCheck(this, MenuItemDetail);

    _initializerDefineProperty(this, "_skus", _descriptor, this);

    _initializerDefineProperty(this, "_data", _descriptor2, this);

    makeObservable(this);
    this.setRawMenuDetailAPIResponse(rawMenuDetailAPIResponse);
  }

  _createClass(MenuItemDetail, [{
    key: "markDirty",
    value: function markDirty() {
      var _this$selectedSKU, _this$selectedSKU$opt;

      (_this$selectedSKU = this.selectedSKU) === null || _this$selectedSKU === void 0 ? void 0 : (_this$selectedSKU$opt = _this$selectedSKU.options) === null || _this$selectedSKU$opt === void 0 ? void 0 : _this$selectedSKU$opt.forEach(function (configProperty) {
        if (configProperty) {
          configProperty === null || configProperty === void 0 ? void 0 : configProperty.setIsDirty(true, true);
        }
      });
    }
  }, {
    key: "processSKUEntries",
    value: function processSKUEntries() {
      var _this = this;

      this._skus = this.filteredMenuSkuBeansWithoutPrice.map(function (rawMenuBean) {
        return new SKU(rawMenuBean, _this);
      });
      var filtered = [];

      if (this.defaultSelectedSku) {
        filtered = this._skus.filter(function (sku) {
          return sku.optionId === _this.defaultSelectedSku;
        });
      }

      var sku2Sel = filtered.length > 0 ? filtered[0] : this._skus.length > 1 ? null : this._skus[0];

      if (sku2Sel) {
        sku2Sel.selected = true;
      }
    }
  }, {
    key: "clearTree",
    value: function clearTree() {
      var _this$_skus;

      var ignoreOptionIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      (_this$_skus = this._skus) === null || _this$_skus === void 0 ? void 0 : _this$_skus.forEach(function (opt) {
        if (ignoreOptionIds.indexOf(opt.optionId) < 0) {
          opt.clearTree();
        }
      });
    }
  }, {
    key: "setRawMenuDetailAPIResponse",
    value: function setRawMenuDetailAPIResponse(rawMenuDetailAPIResponse) {
      var _this2 = this;

      runInAction(function () {
        _this2._data = rawMenuDetailAPIResponse;
      });
      this.processSKUEntries();
    }
  }, {
    key: "findSKU",
    value: function findSKU(optionId) {
      var _this$_skus2;

      var sku = null;
      (_this$_skus2 = this._skus) === null || _this$_skus2 === void 0 ? void 0 : _this$_skus2.forEach(function (tSku) {
        if (tSku.optionId === optionId) {
          sku = tSku;
        }
      });
      return sku;
    }
  }, {
    key: "findSelectionTreeForOptionBySelectedId",
    value: function findSelectionTreeForOptionBySelectedId(selectedId) {
      var _this$_skus3;

      var nodes = [];
      (_this$_skus3 = this._skus) === null || _this$_skus3 === void 0 ? void 0 : _this$_skus3.forEach(function (sku) {
        var propNodes = sku.findSelectionTreeForOptionBySelectedId(selectedId);

        if (propNodes.length > 0) {
          nodes.push.apply(nodes, _toConsumableArray(propNodes));
        }
      });
      return nodes;
    }
  }, {
    key: "options",
    get: function get() {
      return this._skus;
    }
  }, {
    key: "pretty",
    get: function get() {
      return {
        isInValid: this.isInValid,
        isMultiSku: this.isMultiSku,
        id: this.id,
        name: this.name,
        displayPrice: this.displayPrice,
        price: this.price,
        defaultSelectedSku: this.defaultSelectedSku,
        description: this.description,
        isToGo: this.isToGo,
        isComplex: this.isComplex,
        sku: this.selectedSKU ? this.selectedSKU.pretty : null
      };
    }
  }, {
    key: "isInValid",
    get: function get() {
      return this.selectedSKU ? this.selectedSKU.isInValid : true;
    }
  }, {
    key: "isMultiSku",
    get: function get() {
      var _this$_data$skus;

      return ((_this$_data$skus = this._data.skus) === null || _this$_data$skus === void 0 ? void 0 : _this$_data$skus.length) > 1 ? true : false;
    }
  }, {
    key: "selectedSKU",
    get: function get() {
      var filtered = this._skus.filter(function (sku) {
        return sku.selected;
      });

      return filtered.length === 1 ? filtered[0] : null;
    }
  }, {
    key: "id",
    get: function get() {
      var _this$_data;

      return (_this$_data = this._data) === null || _this$_data === void 0 ? void 0 : _this$_data.id;
    }
  }, {
    key: "keywords",
    get: function get() {
      var _this$_data2;

      return (_this$_data2 = this._data) === null || _this$_data2 === void 0 ? void 0 : _this$_data2.keywords;
    }
  }, {
    key: "imageURL",
    get: function get() {
      var _this$_data3, _this$_data3$media, _this$_data3$media$la;

      return (_this$_data3 = this._data) === null || _this$_data3 === void 0 ? void 0 : (_this$_data3$media = _this$_data3.media) === null || _this$_data3$media === void 0 ? void 0 : (_this$_data3$media$la = _this$_data3$media.largeImage) === null || _this$_data3$media$la === void 0 ? void 0 : _this$_data3$media$la.url;
    }
  }, {
    key: "mobileAppSmallImage",
    get: function get() {
      var _this$_data4, _this$_data4$media, _this$_data4$media$sm;

      return (_this$_data4 = this._data) === null || _this$_data4 === void 0 ? void 0 : (_this$_data4$media = _this$_data4.media) === null || _this$_data4$media === void 0 ? void 0 : (_this$_data4$media$sm = _this$_data4$media.smallImage) === null || _this$_data4$media$sm === void 0 ? void 0 : _this$_data4$media$sm.url;
    }
  }, {
    key: "mobileAppLargeImage",
    get: function get() {
      var _this$_data5, _this$_data5$media, _this$_data5$media$la;

      return (_this$_data5 = this._data) === null || _this$_data5 === void 0 ? void 0 : (_this$_data5$media = _this$_data5.media) === null || _this$_data5$media === void 0 ? void 0 : (_this$_data5$media$la = _this$_data5$media.largeImage) === null || _this$_data5$media$la === void 0 ? void 0 : _this$_data5$media$la.url;
    }
  }, {
    key: "name",
    get: function get() {
      var _this$_data6;

      return (_this$_data6 = this._data) === null || _this$_data6 === void 0 ? void 0 : _this$_data6.displayName;
    }
  }, {
    key: "description",
    get: function get() {
      var _this$_data7;

      return (_this$_data7 = this._data) === null || _this$_data7 === void 0 ? void 0 : _this$_data7.description;
    }
  }, {
    key: "longDescription",
    get: function get() {
      var _this$_data8;

      return (_this$_data8 = this._data) === null || _this$_data8 === void 0 ? void 0 : _this$_data8.longDescription;
    } //TODO Change this

  }, {
    key: "defaultSelectedSku",
    get: function get() {
      var _this$_data9, _this$_data9$configs;

      return (_this$_data9 = this._data) === null || _this$_data9 === void 0 ? void 0 : (_this$_data9$configs = _this$_data9.configs) === null || _this$_data9$configs === void 0 ? void 0 : _this$_data9$configs.defaultSelectedSku;
    }
  }, {
    key: "legalDisclaimer",
    get: function get() {
      var _this$_data10;

      return (_this$_data10 = this._data) === null || _this$_data10 === void 0 ? void 0 : _this$_data10.legalDisclaimer;
    }
  }, {
    key: "price",
    get: function get() {
      var _this$_data11;

      return (_this$_data11 = this._data) === null || _this$_data11 === void 0 ? void 0 : _this$_data11.price.value;
    }
  }, {
    key: "displayPrice",
    get: function get() {
      var _this$_data12, _this$_data12$price;

      return (_this$_data12 = this._data) === null || _this$_data12 === void 0 ? void 0 : (_this$_data12$price = _this$_data12.price) === null || _this$_data12$price === void 0 ? void 0 : _this$_data12$price.formattedPrice;
    }
  }, {
    key: "itemTotalPrice",
    get: function get() {
      if (this.selectedSKU) {
        return this.selectedSKU.itemTotalPrice;
      } else {
        return this.price;
      }
    }
  }, {
    key: "indicators",
    get: function get() {
      var _this$_data13;

      return (_this$_data13 = this._data) === null || _this$_data13 === void 0 ? void 0 : _this$_data13.indicators;
    }
  }, {
    key: "isToGo",
    get: function get() {
      var _this$_data14;

      return (_this$_data14 = this._data) === null || _this$_data14 === void 0 ? void 0 : _this$_data14.configs.isToGoEnabled;
    }
  }, {
    key: "isDineInOnly",
    get: function get() {
      return !this.isToGo;
    }
  }, {
    key: "isComplex",
    get: function get() {
      var filteredMenuSkuBeansWithoutPrice = this.filteredMenuSkuBeansWithoutPrice;
      return filteredMenuSkuBeansWithoutPrice && filteredMenuSkuBeansWithoutPrice.length > 0;
    }
  }, {
    key: "filteredMenuSkuBeansWithoutPrice",
    get: function get() {
      var skus = this._data.skus;
      return skus.filter(function (sku) {
        return sku.price.value;
      });
    }
  }, {
    key: "calories",
    get: function get() {
      var _this$_data15, _this$_data15$nutriti;

      return (_this$_data15 = this._data) === null || _this$_data15 === void 0 ? void 0 : (_this$_data15$nutriti = _this$_data15.nutrition) === null || _this$_data15$nutriti === void 0 ? void 0 : _this$_data15$nutriti.fdaMessage;
    }
  }, {
    key: "isAlcohol",
    get: function get() {
      var _this$selectedSKU2;

      return (_this$selectedSKU2 = this.selectedSKU) === null || _this$selectedSKU2 === void 0 ? void 0 : _this$selectedSKU2.isAlcohol;
    }
  }, {
    key: "winePairingIds",
    get: function get() {
      var _this$options, _this$options$;

      return (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$ = _this$options[0]) === null || _this$options$ === void 0 ? void 0 : _this$options$.winePairingIds;
    }
  }, {
    key: "alcoholSubClassification",
    get: function get() {
      var _this$selectedSKU3;

      return (_this$selectedSKU3 = this.selectedSKU) === null || _this$selectedSKU3 === void 0 ? void 0 : _this$selectedSKU3.alcoholSubClassification;
    }
  }, {
    key: "menuId",
    get: function get() {
      var _this$_data16;

      return (_this$_data16 = this._data) === null || _this$_data16 === void 0 ? void 0 : _this$_data16.id;
    }
  }, {
    key: "isDisplayCourseForOrderAhead",
    get: function get() {
      var _this$_data17, _this$_data17$configs;

      return (_this$_data17 = this._data) === null || _this$_data17 === void 0 ? void 0 : (_this$_data17$configs = _this$_data17.configs) === null || _this$_data17$configs === void 0 ? void 0 : _this$_data17$configs.displayCourseForOrderAhead;
    }
  }, {
    key: "alternateCourse",
    get: function get() {
      var _this$_data18, _this$_data18$course;

      return (_this$_data18 = this._data) === null || _this$_data18 === void 0 ? void 0 : (_this$_data18$course = _this$_data18.course) === null || _this$_data18$course === void 0 ? void 0 : _this$_data18$course.alternateCourse;
    }
  }, {
    key: "defaultCourse",
    get: function get() {
      var _this$_data19, _this$_data19$course;

      return (_this$_data19 = this._data) === null || _this$_data19 === void 0 ? void 0 : (_this$_data19$course = _this$_data19.course) === null || _this$_data19$course === void 0 ? void 0 : _this$_data19$course.defaultCourse;
    }
  }, {
    key: "dayPartInfo",
    get: function get() {
      var _this$_data20;

      return (_this$_data20 = this._data) === null || _this$_data20 === void 0 ? void 0 : _this$_data20.dayPartInfo;
    }
  }, {
    key: "advacedOrderingInfo",
    get: function get() {
      var _this$_data21;

      return (_this$_data21 = this._data) === null || _this$_data21 === void 0 ? void 0 : _this$_data21.advanceOrdering;
    }
  }, {
    key: "seoMetaDescription",
    get: function get() {
      var _this$_data22;

      return (_this$_data22 = this._data) === null || _this$_data22 === void 0 ? void 0 : _this$_data22.seoMetaDescription;
    }
  }, {
    key: "displayItemInstruction",
    get: function get() {
      var _this$_data23;

      return (_this$_data23 = this._data) === null || _this$_data23 === void 0 ? void 0 : _this$_data23.displayItemInstruction;
    }
  }]);

  return MenuItemDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_skus", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_data", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "options", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "options"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markDirty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "markDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processSKUEntries", [action], Object.getOwnPropertyDescriptor(_class.prototype, "processSKUEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pretty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pretty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMultiSku", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMultiSku"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedSKU", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedSKU"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "id", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "id"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keywords", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "keywords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobileAppSmallImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobileAppSmallImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobileAppLargeImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobileAppLargeImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "longDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "longDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultSelectedSku", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultSelectedSku"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "legalDisclaimer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "legalDisclaimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "price", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "price"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemTotalPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemTotalPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "indicators", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "indicators"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isToGo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isToGo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDineInOnly", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDineInOnly"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isComplex", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isComplex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredMenuSkuBeansWithoutPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredMenuSkuBeansWithoutPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calories", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "calories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAlcohol", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAlcohol"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "winePairingIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "winePairingIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alcoholSubClassification", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alcoholSubClassification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDisplayCourseForOrderAhead", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDisplayCourseForOrderAhead"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alternateCourse", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alternateCourse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultCourse", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultCourse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dayPartInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dayPartInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "advacedOrderingInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "advacedOrderingInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "seoMetaDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "seoMetaDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayItemInstruction", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayItemInstruction"), _class.prototype)), _class));
export { MenuItemDetail as default };